<script>
  let { variation } = $props();

  const { numberOfReviews, averageRatingRounded } = variation;
  const MAX_RATING_ICONS = 5;

  const ratingFilledCount = Math.trunc(averageRatingRounded);
  const ratingHalfCount = (averageRatingRounded - ratingFilledCount) * 2;
  const ratingEmptyCount = MAX_RATING_ICONS - (ratingFilledCount + ratingHalfCount);

  const createCustomerReviewLandingPageUri = (productId, variationId) =>
    `/kundenbewertungen/${productId}/?variationId=${variationId}`;
</script>

{#if numberOfReviews && averageRatingRounded}
  <div class="reco_comparison__table__rating">
    <div class="reco_comparison__table__rating__icon_container">
      <!--eslint-disable-next-line no-unused-vars-->
      {#each Array(ratingFilledCount) as _}
        <oc-icon-v1 class="reco_comparison__table__rating_star" type="rating-filled"></oc-icon-v1>
      {/each}
      <!--eslint-disable-next-line no-unused-vars-->
      {#each Array(ratingHalfCount) as _}
        <oc-icon-v1 class="reco_comparison__table__rating_star" type="rating-half"></oc-icon-v1>
      {/each}
      <!--eslint-disable-next-line no-unused-vars-->
      {#each Array(ratingEmptyCount) as _}
        <oc-icon-v1 class="reco_comparison__table__rating_star" type="rating-empty"></oc-icon-v1>
      {/each}
    </div>

    <oc-link-v2 class="reco_comparison__table__rating__reviews">
      <a
        href={createCustomerReviewLandingPageUri(variation.productId, variation.id)}
        class="oc-copy-75">({numberOfReviews})</a>
    </oc-link-v2>
  </div>
{/if}

<style lang="scss">
  .reco_comparison__table__rating {
    display: flex;
    align-items: center;
  }
  .reco_comparison__table__rating__icon_container {
    display: flex;
  }

  .reco_comparison__table__rating_star {
    width: 18px;
    height: 18px;
  }

  .reco_comparison__table__rating__reviews {
    margin-left: 6px;
  }
</style>
